import axios from "axios";
import { SERVER_UNKNOWN_ERROR_MESSAGE_KEY } from "./constants";

const isServer = typeof window === "undefined";

const helper_service_url = isServer
  ? process.env.SERVER_SIDE_API_BASE_URL
  : process.env.NEXT_PUBLIC_API_BASE_URL;

type RequestOptions = {
  uri: string;
  body?: Record<string, any>;
  params?: Record<string, any>;
  token?: string;
};

export class ApiError extends Error {
  code: string;
  errors?: ApiError[];

  constructor(message: string, code: string, errors?: ApiError[]) {
    super(message);
    this.code = code;
    this.errors = errors;
  }
}

const get = async <T = any>({ uri, params, token }: RequestOptions): Promise<T> => {
  try {
    const response = await axios.get<void, { data: T }>(`${helper_service_url}${uri}`, {
      params,
      ...(token && { headers: { Authorization: `Bearer ${token}` } }),
    });
    return response.data;
  } catch (error) {
    const errorResponse = error.response?.data ?? {
      message: "",
      code: SERVER_UNKNOWN_ERROR_MESSAGE_KEY,
    };
    throw new ApiError(
      errorResponse?.message,
      errorResponse?.code,
      (errorResponse?.errors || []).map((e: any) => new ApiError(e.message, e.code)),
    );
  }
};

const post = async <T = any>({ uri, body, params, token }: RequestOptions) => {
  try {
    const response = await axios.post<any, { data: T }>(`${helper_service_url}${uri}`, body, {
      params,
      ...(token && { headers: { Authorization: `Bearer ${token}` } }),
    });
    return response.data;
  } catch (error) {
    const errorResponse = error.response?.data ?? {
      message: "",
      code: SERVER_UNKNOWN_ERROR_MESSAGE_KEY,
    };
    throw new ApiError(
      errorResponse?.message,
      errorResponse?.code,
      (errorResponse?.errors || []).map((e: any) => new ApiError(e.message, e.code)),
    );
  }
};

const put = async <T = any>({ uri, body, params, token }: RequestOptions): Promise<T> => {
  try {
    const response = await axios.put<any, { data: T }>(`${helper_service_url}${uri}`, body, {
      params,
      ...(token && { headers: { Authorization: `Bearer ${token}` } }),
    });
    return response.data;
  } catch (error) {
    const errorResponse = error.response?.data ?? {
      message: "",
      code: SERVER_UNKNOWN_ERROR_MESSAGE_KEY,
    };
    throw new ApiError(
      errorResponse?.message,
      errorResponse?.code,
      (errorResponse?.errors || []).map((e: any) => new ApiError(e.message, e.code)),
    );
  }
};

export const apiClient = { get, post, put };
